import propertyService from '../../service/property.service';
import { dataGridPremiumColumns } from '../../utils/helper';

import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { useFormikContext } from 'formik';

const FormsDataGrid = ({ formProperty, disabled, setFormPropertyGroup }) => {
  const { values, setFieldValue } = useFormikContext();

  const handleRowSelectionModelChange = async (newRowSelectionModel) => {
    setFieldValue('formProperty', newRowSelectionModel);

    const selectedGroups = values.formPropertyGroup.filter((group) => newRowSelectionModel.includes(group.formId));

    setFieldValue('formPropertyGroup', selectedGroups);

    if (newRowSelectionModel.length === 0) {
      setFormPropertyGroup([]);
      return;
    }

    const data = await propertyService.getPropertyGroupsForSubmenus({
      data: newRowSelectionModel,
    });

    setFormPropertyGroup(data);
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'subMenuName',
      type: 'string',
      headerName: 'Felületek',
    },
  ]);

  return (
    <DatagridPremiumUi
      sx={{
        '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root': {
          display: 'none',
        },
      }}
      datagridIdentifier={DataGridIdentifiers.FormsDataGrid}
      datagridInitialState={{ density: 'compact' }}
      slots={{
        toolbar: null,
      }}
      height={300}
      columns={columns}
      rows={formProperty}
      getRowId={(row) => row.subMenuId}
      checkboxSelection
      paginationAndfilterMode="client"
      disableRowSelectionOnClick={true}
      rowSelectionModel={values.formProperty}
      isRowSelectable={() => !disabled}
      onRowSelectionModelChange={handleRowSelectionModelChange}
      hideFooter
    />
  );
};

export default FormsDataGrid;
